import { ThemeType } from '@ct-design/@types'
import { Theme } from '../../token/theme'
import CleartripTheme from '../../token/theme/CleartripTheme'
import FlyinTheme from '../../token/theme/FlyinTheme'
const getTheme = (themeType: ThemeType): Theme => {
    switch (themeType) {
        case 'B2C': {
            return CleartripTheme
        }
        case 'FLYIN': {
            return FlyinTheme
        }
        default: {
            return CleartripTheme
        }
    }
}

export default getTheme
